<template>
	<div class="spoiler" :class="{'spoiler--opened' : opened}">
		<button type="button" class="spoiler__button" @click="opened = !opened">
			<slot name="button" :opened="opened"></slot>
		</button>
		<div class="spoiler__body" ref="body" style="height:0;">
			<slot name="body" :opened="opened"></slot>
		</div>
	</div>
</template>
<script lang="ts" setup>
import {ref, watch} from "vue";
import "./Spoiler.scss";

let opened = ref<boolean>(false);
let body = ref<HTMLElement | null>(null);

watch(opened, () => {

	if(body.value){

		let scrollHeight = body.value.scrollHeight;
		let offsetHeight = body.value.offsetHeight;

		body.value.style.height = opened.value
			? (scrollHeight + 'px')
			: '0px';

	}

});

</script>